import { RewardsAction } from "../actions";
import { ApiCaller, Utils } from "../../config";
import { put } from "redux-saga/effects";
import {
    REWARDS_SETTINGS_ENDPOINT,
    REWARDS_SETTINGS_TOGGLE_ENDPOINT,
    REWARDS_SETTINGS_CONFIG_ENDPOINT,
    REWARDS_REFERRAL_CONFIG_ENDPOINT,
    REWARDS_FIRST_PURCHASE_CONFIG_ENDPOINT,
    DAILY_REWARDS_ENDPOINT,
    FREE_PLAY_CONFIG_ENDPOINT,
} from "../../config/variables";

export default class RewardsMiddleware {

    // GET /admin/settings
    static *GetSettings() {
        try {
            const res = yield ApiCaller.Get(REWARDS_SETTINGS_ENDPOINT);
            if (res?.status === 200) {
                yield put(RewardsAction.GetSettings_Success(res?.data?.data));
            } else {
                yield put(RewardsAction.GetSettings_Failure(res?.data));
            }
        } catch (err) {
            yield put(RewardsAction.GetSettings_Failure(err));
        }
    }

    // PATCH /admin/settings/toggle
    static *ToggleSetting({ payload, cb }) {
        try {
            const res = yield ApiCaller.Patch(REWARDS_SETTINGS_TOGGLE_ENDPOINT, {}, payload);
            if (res?.status === 200) {
                yield put(RewardsAction.ToggleSetting_Success(res?.data?.data));
                if (cb) cb();
            } else {
                yield put(RewardsAction.ToggleSetting_Failure(res?.data));
            }
        } catch (err) {
            yield put(RewardsAction.ToggleSetting_Failure(err));
        }
    }

    // GET /admin/settings/config?key=xxx
    static *GetSettingsConfig({ key }) {
        try {
            const res = yield ApiCaller.Get(`${REWARDS_SETTINGS_CONFIG_ENDPOINT}?key=${key}`);
            if (res?.status === 200) {
                yield put(RewardsAction.GetSettingsConfig_Success(res?.data?.data));
            } else {
                yield put(RewardsAction.GetSettingsConfig_Failure(res?.data));
            }
        } catch (err) {
            yield put(RewardsAction.GetSettingsConfig_Failure(err));
        }
    }

    // PATCH /admin/settings/referral-config
    static *UpdateReferralConfig({ payload, cb }) {
        try {
            const res = yield ApiCaller.Patch(REWARDS_REFERRAL_CONFIG_ENDPOINT, {}, payload);
            if (res?.status === 200) {
                yield put(RewardsAction.UpdateReferralConfig_Success(res?.data?.data));
                if (cb) cb();
            } else {
                yield put(RewardsAction.UpdateReferralConfig_Failure(res?.data));
            }
        } catch (err) {
            yield put(RewardsAction.UpdateReferralConfig_Failure(err));
        }
    }

    // PATCH /admin/settings/first-purchase-config
    static *UpdateFirstPurchaseConfig({ payload, cb }) {
        try {
            const res = yield ApiCaller.Patch(REWARDS_FIRST_PURCHASE_CONFIG_ENDPOINT, {}, payload);
            if (res?.status === 200) {
                yield put(RewardsAction.UpdateFirstPurchaseConfig_Success(res?.data?.data));
                if (cb) cb();
            } else {
                yield put(RewardsAction.UpdateFirstPurchaseConfig_Failure(res?.data));
            }
        } catch (err) {
            yield put(RewardsAction.UpdateFirstPurchaseConfig_Failure(err));
        }
    }

    // GET /admin/daily-rewards
    static *GetDailyRewards() {
        try {
            const res = yield ApiCaller.Get(DAILY_REWARDS_ENDPOINT);
            if (res?.status === 200) {
                yield put(RewardsAction.GetDailyRewards_Success(res?.data?.data));
            } else {
                yield put(RewardsAction.GetDailyRewards_Failure(res?.data));
            }
        } catch (err) {
            yield put(RewardsAction.GetDailyRewards_Failure(err));
        }
    }

    // PATCH /admin/daily-rewards
    static *UpdateDailyRewards({ payload, cb }) {
        try {
            const res = yield ApiCaller.Patch(DAILY_REWARDS_ENDPOINT, {}, payload);
            if (res?.status === 200) {
                yield put(RewardsAction.UpdateDailyRewards_Success(res?.data?.data));
                if (cb) cb();
            } else {
                yield put(RewardsAction.UpdateDailyRewards_Failure(res?.data));
            }
        } catch (err) {
            yield put(RewardsAction.UpdateDailyRewards_Failure(err));
        }
    }

    // GET /admin/game/free-play-config
    static *GetFreePlayConfig() {
        try {
            const res = yield ApiCaller.Get(FREE_PLAY_CONFIG_ENDPOINT);
            if (res?.status === 200) {
                yield put(RewardsAction.GetFreePlayConfig_Success(res?.data?.data));
            } else {
                yield put(RewardsAction.GetFreePlayConfig_Failure(res?.data));
            }
        } catch (err) {
            yield put(RewardsAction.GetFreePlayConfig_Failure(err));
        }
    }

    // PATCH /admin/game/free-play-config
    static *UpdateFreePlayConfig({ payload, cb }) {
        try {
            const res = yield ApiCaller.Patch(FREE_PLAY_CONFIG_ENDPOINT, {}, payload);
            if (res?.status === 200) {
                yield put(RewardsAction.UpdateFreePlayConfig_Success(res?.data?.data));
                if (cb) cb();
            } else {
                yield put(RewardsAction.UpdateFreePlayConfig_Failure(res?.data));
            }
        } catch (err) {
            yield put(RewardsAction.UpdateFreePlayConfig_Failure(err));
        }
    }
}

